import { apiSlice } from "./authApi";

export const patientApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getPatientList: builder.query({
            query: ({ page = 1, pageSize = 10 } = {}) => ({
                url: `/patients/?page=${page}&pageSize=${pageSize}`,
                method: "GET",
            }),
            providesTags: (result) => {
                if (result?.results) {
                    return result.results.map((patient) => ({
                        type: "Patient",
                        id: patient.id,
                    }));
                }
                return [{ type: "Patient", id: "LIST" }];
            },
        }),

        getPatient: builder.query({
            query: (id) => ({ url: `/patients/${id}/` }),
            providesTags: (result, error, id) => [{ type: "Patient", id }],
        }),

        searchPatients: builder.query({
            query: ({ page = 1, pageSize = 10, search }) => ({
                url: `/patients/?page=${page}&pageSize=${pageSize}&search=${search}`,
                method: "GET",
            }),
            providesTags: (result) => {
                if (result?.results) {
                    return result.results.map((patient) => ({
                        type: "Patient",
                        id: patient.id,
                    }));
                }
                return [{ type: "Patient", id: "LIST" }];
            },
        }),

        deletePatient: builder.mutation({
            invalidatesTags: (result, error, id) => {
                return [{ type: "Patient", id }];
            },
            query: (id) => {
                return {
                    url: "/patients/" + id + "/",
                    method: "DELETE",
                };
            },
        }),

        createPatient: builder.mutation({
            invalidatesTags: (result, error, patient) => {
                return [
                    {
                        type: "Patient",
                        id: patient.id,
                    },
                ];
            },
            query: (patient) => {
                return {
                    url: "/patients/",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: patient,
                };
            },
        }),

        updatePatient: builder.mutation({
            query: (patient) => ({
                url: `/patients/${patient.id}/`,
                method: "PATCH",
                body: { ...patient },
                headers: {
                    "Content-Type": "application/json",
                },
            }),
            invalidatesTags: (result, error, patient) => {
                return [
                    {
                        type: "Patient",
                        id: patient.id,
                    },
                ];
            },
        }),

        getPatientGenderCount: builder.query({
            query: () => "patient-gender-count/",
        }),

        exportPatientData: builder.mutation({
            query: (format) => ({
                url: `export-patient-data/${format}/`,
                method: "GET",
                responseHandler: async (response) => {
                    if (response.ok) {
                        const blob = await response.blob();
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = `patients.${
                            format === "csv" ? "csv" : "xlsx"
                        }`; // Assuming Excel files are xlsx
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        return response.data;
                    } else {
                        const errorText = await response.text();
                        throw new Error(
                            errorText || "Failed to download the file."
                        );
                    }
                },
            }),
        }),
    }),
});

export const {
    useCreatePatientMutation,
    useGetPatientListQuery,
    useGetPatientQuery,
    useUpdatePatientMutation,
    useDeletePatientMutation,
    useSearchPatientsQuery,
    useGetPatientGenderCountQuery,
    useExportPatientDataMutation,
} = patientApiSlice;
